import './components.scss';

const PageContainer = (props) => {
    return (
      <div className='container'>
        {props.children}
      </div>
    )
  }

  export default PageContainer;